var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Directive } from 'angular-ts-decorators';
let ConvertToNumberDirective = class ConvertToNumberDirective {
};
ConvertToNumberDirective = __decorate([
    Directive({
        selector: 'convert-to-number',
        require: 'ngModel',
        link: function (scope, element, attrs, ngModel) {
            if (!ngModel) {
                throw new TypeError(`'convert-to-number' can only be used as an attribute of an input element.`);
            }
            ngModel.$parsers.push((val) => {
                return val ? parseInt(String(val), 10) : null;
            });
            ngModel.$formatters.push((val) => {
                return val ? String(val) : null;
            });
        },
    })
], ConvertToNumberDirective);
export { ConvertToNumberDirective };
